module.exports = __webpack_public_path__ + "img/1579587175.dfae842d.jpg";